import React, { memo } from "react";
// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
// utils
import { isEmpty } from "@swiggy-private/core-ui";
// styles
import { TitleTag, DeliveryTagWrapper, DeliveryTagImageWrapper } from "./styles";
import HeaderAlertText from "./HeaderAlertText";
// constants
import { STATIC_TEXTS } from "@cart-client/constants/GiftingCart";

interface DeliveryTagTitleAndSubtitleProps {
    title: string;
    slaTime?: string;
    deliveryTagImage?: string;
    isUnserviceable?: boolean;
}

const DeliveryTagTitleAndSubtitle = ({
    title,
    slaTime,
    deliveryTagImage,
    isUnserviceable,
}: DeliveryTagTitleAndSubtitleProps) => {
    if (isEmpty(title)) return null;
    return (
        <div>
            <TitleTag variant="V2.overline.neutral.medium" maxLines={1} dangerouslySetInnerHTML={{ __html: title }} />
            {!isEmpty(slaTime) && !isUnserviceable && (
                <DeliveryTagWrapper>
                    <Text variant="V2.body1.neutral.bold" color="text_Highest_Emphasis">
                        {slaTime}
                    </Text>
                    {!isEmpty(deliveryTagImage) && (
                        <DeliveryTagImageWrapper>
                            <Image cloudinaryId={deliveryTagImage} width="100%" height="100%" fit="cover" />
                        </DeliveryTagImageWrapper>
                    )}
                </DeliveryTagWrapper>
            )}
            {isUnserviceable && <HeaderAlertText text={STATIC_TEXTS.HEADER_UNSERVICEABLE} />}
        </div>
    );
};

export default memo(DeliveryTagTitleAndSubtitle);
